import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-bus-history-selector-student-results",
	templateUrl: "./bus-history-selector-student-results.component.html",
	styleUrls: ["./bus-history-selector-student-results.component.css"],
})
export class BusHistorySelectorStudentResultsComponent implements OnInit {
	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() TableLoading: any = false;
	@Output() SelectedChanged: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPersons: any = [];
	@Input() lstPerson: any = [];

	//Filter lists
	lstCurrentBusNbr: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		// { field: 'CurrentBusNbr', header: 'On Bus' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		// this.lstCurrentBusNbr = Array.from(new Set(this.lstPerson.map((item: any) => item.CurrentBusNbr))).sort();
		this.SelectedChanged.emit(this.SelectedPersons);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.UpdateData();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onCheckClick() {
		this.SelectedChanged.emit(this.SelectedPersons);
	}
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedChanged.emit(this.SelectedPersons);
		// this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedChanged.emit(this.SelectedPersons);
		// this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		this.SelectedChanged.emit(this.SelectedPersons);
		// this.SelectedPerson = Person;
	}
	////////////////////////////////////////////
}
